import { EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConsentResponse } from '@ent-regis/entregis-ts-angular';
import { ConsentAcceptanceRequest } from '@ent-regis/entregis-ts-angular/model/consentAcceptanceRequest';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  styleUrls: ['./consent.component.scss']
})
export class ConsentComponent implements OnInit {

  consentForm: FormGroup = new FormGroup({
    consentArray: new FormArray([])
  })

  get consentListFA() { return this.consentForm.controls.consentArray as FormArray; }

  @Input() onSuccess: (consents: ConsentAcceptanceRequest[]) => void = undefined;
  @Input() consents: ConsentResponse[] = [];
  @Input() registerTitle?: string;
  @Input() startDate?: number;
  @Input() endDate?: number;
  @Output() onSuccessEvent = new EventEmitter<ConsentAcceptanceRequest[]>();

  registerPeriod?: string;

  constructor() { }

  ngOnInit() {
    this.consents.forEach(consent => {
      this.consentListFA.push(new FormGroup({
        name: new FormControl(consent.consentName),
        content: new FormControl(consent.consentContent),
        isRequired: new FormControl(consent.isRequired),
        versionString: new FormControl(consent.consentVersionString),
        consentId: new FormControl(consent.consentVersionId),
        accept: new FormControl(null, Validators.required)
      }))
    });
  }

  ngOnChanges(): void {
    if (this.startDate && this.endDate) {
      this.registerPeriod = this.formatRegisterPeriod(this.startDate, this.endDate);
    }
  }

  get consentAcceptedForm() { return this.consentForm.controls.consentAccepted; }

  acceptConsent() {
    if (!this.consentForm.valid) {
      this.consentForm.markAllAsTouched();
      return;
    }

    const arr = this.consentListFA.controls.map((x: FormGroup) => {
      return {
        consentVersionId: x.controls.consentId.value,
        isAccept: x.controls.accept.value
      }
    });

    if (this.onSuccess) {
      this.onSuccess(arr)
    }
    this.onSuccessEvent.emit(arr);
  }

  allConsentChecked(): boolean {
    return this.consentListFA.controls.every((control: any) => {
      const form = control;
      const isRequired = form.controls.isRequired.value;
      const accept = form.controls.accept.value;

      if (isRequired) {
        return accept === true;
      }

      return accept !== null && accept !== undefined;
    });
  }

  private formatRegisterPeriod(start: number, end: number): string {
    const s = new Date(start);
    const e = new Date(end);

    const monthFormatter = new Intl.DateTimeFormat('en-US', { month: 'short' });

    const sm = monthFormatter.format(s);
    const em = monthFormatter.format(e);

    const sy = s.getFullYear();
    const ey = e.getFullYear();

    const sd = s.getDate();
    const ed = e.getDate();

    // same month + same year
    if (sm === em && sy === ey) {
      return `${sm} ${sd}–${ed}, ${sy}`;
    }

    // different month but same year
    if (sy === ey) {
      return `${sm} ${sd} – ${em} ${ed}, ${sy}`;
    }

    // different year
    return `${sm} ${sd}, ${sy} – ${em} ${ed}, ${ey}`;
  }
}
